<template>
  <div class="content-block">
    <h2 class="product-heading">
      {{ title }}
    </h2>
    <div v-for="(paragraph, index) in paragraphs" :key="index">
      <p class="product-paragraph">
        {{ paragraph }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductPageIntro',
  props: {
    title: {
      type: String,
      required: true
    },
    paragraphs: {
      type: Array,
      required: true
    }
  }
};
</script> 